// src/utils/firebaseErrorMessages.js

// a map of all Firebase Auth error codes (admin + client) to user-friendly messages
const firebaseAuthErrorMessages = {
    'auth/claims-too-large': 'The data you provided is too large. Please try again.',
    'auth/email-already-exists': 'That email is already in use. Please use another.',
    'auth/id-token-expired': 'Your session has expired. Please sign in again.',
    'auth/id-token-revoked': 'Your session was revoked. Please sign in again.',
    'auth/insufficient-permission': 'You don’t have permission to perform this action.',
    'auth/internal-error': 'We’re having trouble right now. Please try again later.',
    'auth/invalid-argument': 'An internal error occurred. Please retry.',
    'auth/invalid-claims': 'There was a problem with the data. Please try again.',
    'auth/invalid-continue-uri': 'A required URL is invalid. Please contact support.',
    'auth/invalid-creation-time': 'A required timestamp is invalid. Please contact support.',
    'auth/invalid-credential': 'We couldn’t verify your credentials. Please try again.',
    'auth/invalid-disabled-field': 'A required field has an invalid value.',
    'auth/invalid-display-name': 'That display name isn’t allowed.',
    'auth/invalid-dynamic-link-domain': 'This link isn’t authorized for this project.',
    'auth/invalid-email': 'That email looks invalid. Please check and try again.',
    'auth/invalid-email-verified': 'That value for emailVerified is invalid.',
    'auth/invalid-hash-algorithm': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-block-size': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-derived-key-length': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-key': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-memory-cost': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-parallelization': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-rounds': 'An internal error occurred. Please retry.',
    'auth/invalid-hash-salt-separator': 'An internal error occurred. Please retry.',
    'auth/invalid-id-token': 'Your session isn’t valid. Please sign in again.',
    'auth/invalid-last-sign-in-time': 'An internal error occurred. Please retry.',
    'auth/invalid-page-token': 'An internal error occurred. Please retry.',
    'auth/invalid-password': 'Password must be at least 6 characters.',
    'auth/invalid-password-hash': 'An internal error occurred. Please retry.',
    'auth/invalid-password-salt': 'An internal error occurred. Please retry.',
    'auth/invalid-phone-number': 'That phone number looks invalid. Please check and try again.',
    'auth/invalid-photo-url': 'That URL looks invalid. Please check and try again.',
    'auth/invalid-provider-data': 'An internal error occurred. Please retry.',
    'auth/invalid-provider-id': 'An internal error occurred. Please retry.',
    'auth/invalid-oauth-responsetype': 'An internal error occurred. Please retry.',
    'auth/invalid-session-cookie-duration': 'An internal error occurred. Please retry.',
    'auth/invalid-uid': 'An internal error occurred. Please retry.',
    'auth/invalid-user-import': 'An internal error occurred. Please retry.',
    'auth/maximum-user-count-exceeded': 'Too many users exist. Please contact support.',
    'auth/missing-android-pkg-name': 'An internal error occurred. Please retry.',
    'auth/missing-continue-uri': 'A required URL is missing. Please contact support.',
    'auth/missing-hash-algorithm': 'An internal error occurred. Please retry.',
    'auth/missing-ios-bundle-id': 'An internal error occurred. Please retry.',
    'auth/missing-uid': 'An internal error occurred. Please retry.',
    'auth/missing-oauth-client-secret': 'An internal error occurred. Please retry.',
    'auth/operation-not-allowed': 'This sign-in method is disabled. Please enable it in Firebase console.',
    'auth/phone-number-already-exists': 'That phone number is already in use.',
    'auth/project-not-found': 'We couldn’t find our project. Please contact support.',
    'auth/reserved-claims': 'An internal error occurred. Please retry.',
    'auth/session-cookie-expired': 'Your session has expired. Please sign in again.',
    'auth/session-cookie-revoked': 'Your session was revoked. Please sign in again.',
    'auth/too-many-requests': 'You’ve made too many attempts. Please wait a moment and try again.',
    'auth/uid-already-exists': 'That user ID is already in use.',
    'auth/unauthorized-continue-uri': 'This link isn’t allowed. Please contact support.',
    'auth/user-not-found': 'No account found with those credentials.',
    'auth/account-exists-with-different-credential': "This phone number has already been verified by another account.",
};

export function getFriendlyFirebaseError(errorOrCode) {
    const code = typeof errorOrCode === 'string'
        ? errorOrCode
        : errorOrCode?.code;
    return firebaseAuthErrorMessages[code] || (errorOrCode?.message ?? 'Something went wrong. Please try again.');
}